export const REQUEST_PLAN_DETAILS = 'REQUEST_PLAN_DETAILS';
export const RECEIVE_PLAN_DETAILS = 'RECEIVE_PLAN_DETAILS';
export const PLAN_DETAILS_REQUEST_FAILED = 'PLAN_DETAILS_REQUEST_FAILED';
export const PLAN_DETAILS_RESET_STATE = 'PLAN_DETAILS_RESET_STATE';
